import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DoctorsNextButtonComponent } from './doctors-next-button/doctors-next-button.component';
import { DoctorsNextForgotPasswordComponent } from './doctors-next-forgot-password/doctors-next-forgot-password.component';
import { DoctorsNextLoginConnectCportalComponent } from './doctors-next-login-connect-cportal/doctors-next-login-connect-cportal.component';
import { DoctorsNextLoginComponent } from './doctors-next-login/doctors-next-login.component';
import { DoctorsNextRadioButtonComponent } from './doctors-next-radio-button/doctors-next-radio-button.component';
import { DoctorsNextRegisterAdditionalComponent } from './doctors-next-register-additional/doctors-next-register-additional.component';
import { DoctorsNextRegisterConfirmComponent } from './doctors-next-register-confirm/doctors-next-register-confirm.component';
import { DoctorsNextRegisterConnectCportalComponent } from './doctors-next-register-connect-cportal/doctors-next-register-connect-cportal.component';
import { DoctorsNextRegisterResendComponent } from './doctors-next-register-resend/doctors-next-register-resend.component';
import { DoctorsNextRegisterSendComponent } from './doctors-next-register-send/doctors-next-register-send.component';
import { DoctorsNextRegisterComponent } from './doctors-next-register/doctors-next-register.component';
import { DoctorsNextResetPasswordComponent } from './doctors-next-reset-password/doctors-next-reset-password.component';
import { DoctorsNextSelectDepartmentsComponent } from './doctors-next-select-departments/doctors-next-select-departments.component';
import { DoctorsNextUnblockComponent } from './doctors-next-unblock/doctors-next-unblock.component';
import { DoctorsNextComponent } from './doctors-next.component';

@NgModule({
  declarations: [
    DoctorsNextComponent,
    DoctorsNextLoginComponent,
    DoctorsNextRegisterComponent,
    DoctorsNextUnblockComponent,
    DoctorsNextRegisterSendComponent,
    DoctorsNextForgotPasswordComponent,
    DoctorsNextResetPasswordComponent,
    DoctorsNextLoginConnectCportalComponent,
    DoctorsNextRegisterConnectCportalComponent,
    DoctorsNextRegisterResendComponent,
    DoctorsNextRegisterAdditionalComponent,
    DoctorsNextRadioButtonComponent,
    DoctorsNextSelectDepartmentsComponent,
    DoctorsNextButtonComponent,
    DoctorsNextRegisterConfirmComponent,
  ],
  imports: [CommonModule, NgxSpinnerModule, FormsModule],
  exports: [
    DoctorsNextResetPasswordComponent,
    DoctorsNextComponent,
    DoctorsNextRegisterSendComponent,
    DoctorsNextUnblockComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DoctorsNextModule {}
